import React from 'react';
import '../../styles/table-main/main.css';


const Main = () => {
    return (
        <div id='tableMain'>
            <div className="table-inner-main">
                <div className="container mt-5 mb-5 admin-container">
                    <div className="row">
                        <div className="col-md-12 pull-left flip sm-pull-none">
                            <div className="admin-table">
                                <h2 className="my-heading">Important Emails</h2>
                                {/* <p style="font-size: large; font-weight: 500; line-height: 25px;">Govt. & Aided, Self Financing, Professional Courses Inst./Colleges (District wise)</p> */}
                                <div className="table-scrollable">
                                    <table className="table table-bordered">
                                        <thead>
                                            <tr>
                                                <th>S.No</th>
                                                <th>Name</th>
                                                <th>Designation</th>
                                                <th>Email Id</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr>
                                                <td>1.</td>
                                                <td>Prof. Sangeeta Shukla</td>
                                                <td>Vice Chancellor</td>
                                                <td>vc@ccsuniversity.ac.in</td>
                                            </tr>
                                            <tr>
                                                <td>2.</td>
                                                <td>Shri Ajay Kumar Yadav</td>
                                                <td>Registrar </td>
                                                <td>registrar@ccsuniversity.ac.in</td>
                                            </tr>
                                            <tr>
                                                <td>3.</td>
                                                <td>Prof. Rahul Kumar</td>
                                                <td>Dean of Agriculture</td>
                                                <td>deanagriculture@ccsuniversity.ac.in</td>
                                            </tr>
                                            <tr>
                                                <td>4.</td>
                                                <td>Prof. Atvir Singh</td>
                                                <td>Dean of Arts</td>
                                                <td>deanarts@ccsuniversity.ac.in</td>
                                            </tr>
                                            <tr>
                                                <td>5.</td>
                                                <td>Prof. Rakesh Sharma</td>
                                                <td>Dean of Education</td>
                                                <td>deaneducation@ccsuniversity.ac.in</td>
                                            </tr>
                                            <tr>
                                                <td>6.</td>
                                                <td>Prof. Hare Krishna</td>
                                                <td>Dean of Science</td>
                                                <td>deanscience@ccsuniversity.ac.in</td>
                                            </tr>
                                            <tr>
                                                <td>7.</td>
                                                <td>Prof. R.K. Soni</td>
                                                <td>Dean of Technology</td>
                                                <td>deantechnology@ccsuniversity.ac.in</td>
                                            </tr>
                                            <tr>
                                                <td>8.</td>
                                                <td>Prof. Bhupendra Singh</td>
                                                <td>Dean of DSW</td>
                                                <td>dsw@ccsuniversity.ac.in</td>
                                            </tr>
                                            <tr>
                                                <td>9.</td>
                                                <td>Prof. Beer Pal Singh</td>
                                                <td>Proctor</td>
                                                <td>proctor@ccsuniversity.ac.in</td>
                                            </tr>
                                            <tr>
                                                <td>10.</td>
                                                <td>Prof. Pankaj Tyagi</td>
                                                <td>Dean of Law</td>
                                                <td>deanlaw@ccsuniversity.ac.in</td>
                                            </tr>
                                            <tr>
                                                <td>11.</td>
                                                <td>Dr. R.C. Gupta</td>
                                                <td>Dean of Medicine</td>
                                                <td>deanmedicine@ccsuniversity.ac.in</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </div>
    )
}

export default Main;